export default "__VITE_ASSET__DknJKU14__"